module.exports = __webpack_public_path__ + "static/media/paypal.c02e486b.svg";